/* global document */
/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import SearchResultItem from './SearchResultItem';
import suitcss from '../../../helpers/suitcss';
import MediaImage from '../../basics/media/MediaImage';
import TextHeadline from '../../basics/text/TextHeadline';
import Link from '../../basics/text/TextLink';
import Tabs from '../../basics/tab/Tabs';

const componentName = 'SearchResults';
class SearchResultList extends React.Component {
  constructor(props) {
    super(props);
    const { searchResults, searchMetaInfo, preSelectedFacet } = props;
    this.baseResultsToDisplay = 5;
    const availableFacets = Object.keys(searchMetaInfo.counts.facets);
    const sortedSearchResults = SearchResultList.sortResultByFacet(availableFacets, searchResults);

    this.state = {
      hitOffset: this.baseResultsToDisplay,
      activeResults: sortedSearchResults[preSelectedFacet],
      availableFacets,
      sortedSearchResultsByFacet: sortedSearchResults,
      activeFacet: preSelectedFacet,
      appliedFilter: {
        action: 'add filter',
        updatedFilter: [],
        appliedFilters: [{ facet: 'search filter', value: preSelectedFacet }],
      },
    };
    this.setLoadMoreOffset = this.setLoadMoreOffset.bind(this);
  }

  static sortResultByFacet(facets, data) {
    const sortedData = {};
    sortedData.all = data;
    for (let i = 0; i < facets.length; i++) {
      sortedData[facets[i]] = data.filter(result => result.facet === facets[i]);
    }
    return sortedData;
  }

  // noinspection JSCheckFunctionSignatures
  componentDidUpdate(prevProps) {
    const { searchResults, searchMetaInfo, preSelectedFacet } = this.props;

    if (prevProps.searchResults !== searchResults) {
      const availableFacets = Object.keys(searchMetaInfo.counts.facets);
      const sortedSearchResults = SearchResultList.sortResultByFacet(
        availableFacets,
        searchResults,
      );

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        hitOffset: this.baseResultsToDisplay,
        activeResults: sortedSearchResults[preSelectedFacet],
        availableFacets,
        sortedSearchResultsByFacet: sortedSearchResults,
        activeFacet: preSelectedFacet,
      });
    }
  }

  //------------------------------------------------------------------------------------------------
  //  Helper
  //------------------------------------------------------------------------------------------------
  async setLoadMoreOffset() {
    this.setState(prevState => ({
      ...prevState,
      hitOffset: prevState.hitOffset + this.baseResultsToDisplay,
    }));
    setTimeout(() => {
      const { hitOffset } = this.state;
      document.querySelector(`.SearchResults>.SearchResultItem:nth-of-type(${hitOffset - this.baseResultsToDisplay + 1})>a`).focus();
    }, 50);
  }

  renderNothingWasFound() {
    const { userInteraction, resultsSorry } = this.props;
    return (userInteraction && (
      <div
        className={suitcss({
          descendantName: 'noResults',
        }, this)}
      >
        <MediaImage src="/files/icons/icon-search-no-result.svg" alt="no results" />
        <TextHeadline bold element="h2" size="m" utilities={['marginTop']}>
          {resultsSorry}
        </TextHeadline>
      </div>
    ));
  }

  renderResultFilter() {
    const { searchMetaInfo: { counts }, trackClick } = this.props;
    const availableFacets = Object.keys(counts.facets);
    const { activeFacet } = this.state;

    // add all facet to list
    const preparedFacets = [{ key: 'all', label: `Alles (${counts.total})` }];
    availableFacets.forEach((facet) => {
      preparedFacets.push({ key: facet, label: `${facet} (${counts.facets[facet]})` });
    });

    const handleTabClick = (facet) => {
      const { appliedFilter, sortedSearchResultsByFacet } = this.state;
      const updatedFilter = { facet: 'search filter', value: facet };
      const filterUpdate = appliedFilter;
      filterUpdate.appliedFilters.push(updatedFilter);
      trackClick({ ...appliedFilter, updatedFilter });
      this.setState({
        appliedFilter: { ...appliedFilter, ...filterUpdate },
        activeFacet: facet.key,
        activeResults: sortedSearchResultsByFacet?.[facet.key],
      });
    };

    return (
      <Tabs
        tabs={preparedFacets}
        theme="underlined"
        clickHandler={handleTabClick}
        activeTab={preparedFacets.findIndex(el => el.key === activeFacet)}
      />
    );
  }

  renderSearchResultItems() {
    const { activeResults, hitOffset } = this.state;
    const searchResultsToDisplay = activeResults.filter((item, index) => index <= (hitOffset - 1));
    return (
      this.state.activeResults.length !== 0 ?
        searchResultsToDisplay.map((item) => <SearchResultItem {...item} key={`${item.url}-${item.title}`} />) :
        this.renderNothingWasFound()
    );
  }

  renderingPagination() {
    const { activeResults, hitOffset } = this.state;
    const { moreAction } = this.props;
    return hitOffset < activeResults.length && (
      <div
        className={suitcss({
          componentName,
          descendantName: 'showMoreButton',
        }, this)}
      >
        <Link
          asButton
          withoutArrow
          element="button"
          buttonFilled
          onClick={this.setLoadMoreOffset}
        >
          {moreAction}
        </Link>
      </div>
    );
  }

  //------------------------------------------------------------------------------------------------
  //  render
  //------------------------------------------------------------------------------------------------
  render() {
    return (
      <section
        className={suitcss({
          componentName,
        })}
      >
        {this.renderResultFilter()}
        {this.renderSearchResultItems()}
        {this.renderingPagination()}
      </section>
    );
  }
}

//------------------------------------------------------------------------------------------------
//  Proptypes
//------------------------------------------------------------------------------------------------

SearchResultList.propTypes = {
  searchMetaInfo: PropTypes.object.isRequired,
  searchResults: PropTypes.array.isRequired,
  moreAction: PropTypes.string.isRequired,
  isGlobalSearch: PropTypes.bool.isRequired,
  preSelectedFacet: PropTypes.string.isRequired,
  userInteraction: PropTypes.bool,
  resultsSorry: PropTypes.string,
  trackClick: PropTypes.func,
};

export default SearchResultList;
